<template>
  <div class="card card-height">
    <div class="table-responsive">
      <table class="table">
        <thead>
        <tr>
          <th>Photo</th>
          <th class="nowrap">Full Name</th>
          <th class="nowrap">Designation</th>
          <th class="nowrap">Emp ID</th>
          <th class="nowrap">Linked User</th>
          <th class="nowrap">Date of Birth</th>
          <th class="nowrap">Joined Date</th>
          <th class="nowrap">Department</th>
          <th class="nowrap">Branch</th>
          <th class="nowrap">Gender</th>
          <th class="nowrap">Email</th>
          <th class="nowrap">Mobile No</th>
          <th class="nowrap">Blood Group</th>
          <th class="nowrap">Status</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, i) in contacts" :key="i">
          <td><img :src="item.photo" alt="Generic placeholder image" class="w-44"/></td>
          <td @click="handleEdit(item)" class="text-decoration-underline ">{{ item.full_name }}</td>
          <td>{{ item.employment_designation_name }}</td>
          <td>{{ item.serial_no }}</td>
          <td>{{ item.linked_user_name }}</td>
          <td>{{ item.birthday }}</td>
          <td>{{ item.employment_date_of_joining }}</td>
          <td>{{ item.employment_department_name }}</td>
          <td>{{ item.employment_branch_name }}</td>
          <td class="text-capitalize">{{ item.gender }}</td>
          <td>{{ item.email }}</td>
          <td>{{ item.phone }}</td>
          <td>{{ item.blood_group }}</td>
          <td>{{ item.employment_job_status_name }}</td>
        </tr>
        </tbody>
      </table>
      <p v-if="!contacts.length" class="text-center mt-5">No data</p>
    </div>
  </div>
</template>

<script setup>
import {useRoute, useRouter} from "vue-router";

const props = defineProps({
  contacts: Array
})
const router = useRouter()
const route = useRoute()

const handleEdit = (contact) => {
  let routeQuery = { ...route.query };
  routeQuery.contactId = contact.id;
  routeQuery.type = contact.contact_type;
  delete routeQuery.page;

  let hashValue = contact.contact_type === 'person' ? '#basic-info' : '#org-basic-info';

  const resolved = router.resolve({
    name: 'add-employee',
    query: routeQuery,
    hash: hashValue
  });

  window.open(resolved.href, '_blank');
};

</script>
<style scoped>
.card--height {
  min-height: 200px
}
.nowrap {
  white-space: nowrap;
}
</style>
